import { Observable } from "rxjs";

import upp from 'app/app.module';
import { determinePlatform, Platform } from 'shared/engine-dynamic';

export class InstallationPromptComponent {
    static $inject = [ '$scope', '$q', 'config', 'installationPrompt' ];
    constructor($scope, $q, config, installationPrompt) {
        let showAndroid = false;
        let showIos = false;
        let childuppName = '';
        let childuppHost = '';
        let childuppLogoUrl = '';
        let close = () => {
            showAndroid = false;
            showIos = false;
        };
        let addToHome = () => {
            installationPrompt.showBrowserInstallationPrompt()
            .then(() => close())
            .catch(() => close());
        }

        Object.defineProperties(this, {
            showAndroid: { get: () => showAndroid },
            showIos: { get: () => showIos },
            childuppName: { get: () => childuppName },
            childuppHost: { get: () => childuppHost },
            childuppLogoUrl: { get: () => childuppLogoUrl },
            close: { get: () => close },
            addToHome: { get: () => addToHome },
        });

        const changesSubscription = Observable.combineLatest(
            Observable.fromPromise(config.getChilduppName()),
            Observable.fromPromise(config.getWebAppURL()),
            Observable.fromPromise(config.getLogoPath()),
            installationPrompt.shouldShowPrompt$,
        ).subscribe(([ name, url, logo, showPrompt ]) => {
            $scope.$evalAsync(() => {
                if (name && logo && url && showPrompt) {
                    // Setup the common properties from the childupp config
                    childuppName = name;
                    childuppHost = new URL(url).hostname;
                    childuppLogoUrl = logo;
                    // Determine which promtp we should show
                    const platform = determinePlatform();
                    showAndroid = showPrompt && platform === Platform.ANDROID;
                    showIos = showPrompt && platform === Platform.IOS;
                    if (showAndroid || showIos) {
                        installationPrompt.promptHasBeenShown();
                    }
                }
            });
        });

        $scope.$on('$destroy', () => {
            changesSubscription.unsubscribe();
        })
    }
}

upp.directive('installationPrompt', function() {
    return {
        restrict: 'E',
        templateUrl: require('./installation-prompt.component.html'),
        styles: require('./installation-prompt.component.less'),
        controllerAs: '$ctrl',
        controller: InstallationPromptComponent,
    };
});



// WEBPACK FOOTER //
// ./src/app/common/components/installation-prompt/installation-prompt.component.js